import { render, staticRenderFns } from "./GeneralSidebarList.vue?vue&type=template&id=189b2bda&scoped=true"
import script from "./GeneralSidebarList.vue?vue&type=script&lang=ts"
export * from "./GeneralSidebarList.vue?vue&type=script&lang=ts"
import style0 from "./GeneralSidebarList.vue?vue&type=style&index=0&id=189b2bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b2bda",
  null
  
)

export default component.exports